import Swiper from '../../../../../../libs/swiper/swiper-bundle@10.0.4.min.js';

window.addEventListener('DOMContentLoaded', () =>
{ 
  const sliderMini = document.querySelector('.swiper-mini');
  const sliderMain = document.querySelector('.swiper-main');

  const swiperMini = new Swiper(sliderMini, {
    slidesPerView: 3,
    spaceBetween: 12,
    watchOverflow: true,
    freeMode: true,
    loop: true,
    breakpoints:
    {
      744:
      {
        slidesPerView: 5,
      },
    },
  });

  const swiperMain = new Swiper(sliderMain, {
    spaceBetween: 16,
    loop: true,
    autoHeight: true,
    pagination: {
      el: '.slider__pag',
      type: 'custom',
      renderCustom: function (swiper) {
        const current = swiper.realIndex + 1; 
        const total = swiper.slides.length;
        return current + '/' + total;
      },
    },
    thumbs: {
      swiper: swiperMini,
    },
    breakpoints:
    {
      1160:
      {
        slidesPerView: 1,
      },
    },
  });
  const btnNext = document.querySelector('.slider__button--next');
  btnNext?.addEventListener('click', () => swiperMain.slideNext());

  const btnPrev = document.querySelector('.slider__button--prev');
  btnPrev?.addEventListener('click', () => swiperMain.slidePrev());

  const updatePrevButtonVisibility = () => {
    if (swiperMain.realIndex > 0) {
      btnPrev.style.display = 'block';
    } else {
      btnPrev.style.display = 'none'; 
    }
  };

  swiperMain.on('slideChange', () => {
    updatePrevButtonVisibility();
  });

  updatePrevButtonVisibility();
});